import { render, staticRenderFns } from "./FileManager.vue?vue&type=template&id=0c864ca2&scoped=true&"
import script from "./FileManager.vue?vue&type=script&lang=ts&"
export * from "./FileManager.vue?vue&type=script&lang=ts&"
import style0 from "./FileManager.vue?vue&type=style&index=0&id=0c864ca2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c864ca2",
  null
  
)

export default component.exports